import { BellRing } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Button, Modal } from '@/components/ui'

import { usePushNotifications } from '../hooks/usePushNotifications'

const OPEN_DELAY_MS = 2_000
/** Em Meu perfil já existe o card de notificações. */
const HIDDEN_PATHS = ['/meu-perfil']

/**
 * Convite para ativar o Web Push. O pedido de permissão do navegador só é
 * disparado pelo clique em "Ativar" — pedir sozinho faz o Chrome silenciar o
 * prompt e o Safari bloquear.
 *
 * Reaparece a cada login enquanto as notificações não estiverem ativas: o
 * "Agora não" vale só enquanto o `AppShell` estiver montado (logout/login ou
 * recarregar a página o reabrem).
 */
export function PushPermissionPrompt() {
  const { pathname } = useLocation()
  const { status, enable } = usePushNotifications()
  const [dismissed, setDismissed] = useState(false)
  const [delayElapsed, setDelayElapsed] = useState(false)

  useEffect(() => {
    const timeoutId = setTimeout(() => setDelayElapsed(true), OPEN_DELAY_MS)
    return () => clearTimeout(timeoutId)
  }, [])

  const open =
    delayElapsed && !dismissed && status === 'disabled' && !HIDDEN_PATHS.includes(pathname)

  const close = () => setDismissed(true)

  const activate = () => {
    // `enable()` precisa rodar dentro do clique (gesto do usuário).
    void enable()
    setDismissed(true)
  }

  return (
    <Modal
      open={open}
      onClose={close}
      title="Fique por dentro"
      footer={
        <>
          <Button variant="ghost" onClick={close}>
            Agora não
          </Button>
          <Button onClick={activate}>Ativar notificações</Button>
        </>
      }
    >
      <div className="flex items-start gap-3">
        <span className="grid size-10 shrink-0 place-items-center rounded-lg bg-brand/10 text-brand">
          <BellRing className="size-5" />
        </span>
        <p className="text-sm text-fg-muted">
          Receba avisos de novos comunicados e eventos do RH mesmo com o app fechado.
        </p>
      </div>
    </Modal>
  )
}
